module.exports = __webpack_public_path__ + "img/sample.39e76d24.png";